<template>
  <div class="markdown__editor" @keyup.meta.enter="editionDone" @keyup.esc="editionCanceled">
    <div class="markdown__editor-wrapper">
      <div class="markdown__editor-edition-box" :class="compact && 'compact'">
        <!-- edit textarea -->
        <AppTextArea
          v-model="markedText"
          class="markdown__editor-draft"
          :placeholder="placeholder"
          autoHeight
        />
        <!-- parsed text -->
        <div v-if="!compact" class="markdown__editor-preview" v-markdown="markedText"></div>
      </div>
      <!-- actions -->
      <div class="markdown__editor-actions">
        <AppButton @click="editionDone"> Guardar </AppButton>
        <AppButtonIcon icon="fal fa-times" @click="editionCanceled" />
      </div>
    </div>
  </div>
</template>

<script>
// Utilities
// Components
import AppButton from 'Ui/AppButton'
import AppTextArea from 'Ui/AppTextArea'
import AppButtonIcon from 'Ui/AppButtonIcon'

export default {
  name: 'MarkdownEditor',

  components: {
    AppButton,
    AppTextArea,
    AppButtonIcon,
  },

  props: {
    toParse: {
      type: String,
      default: '',
    },

    placeholder: {
      type: String,
      default: '',
    },

    compact: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      timeout: null,
      markedText: this.toParse,
    }
  },

  methods: {
    editionDone() {
      this.$emit('edited', this.trimmedText)
    },

    editionCanceled() {
      this.$emit('canceled', this.trimmedText)
    },
  },

  computed: {
    trimmedText() {
      return this.markedText.trim()
    },
  },

  mounted() {
    if (!this.$el) return
    const draft = this.$el.querySelector('.markdown__editor-draft textarea')
    draft && draft.focus()
  },
}
</script>

<style scoped>
.markdown__editor-wrapper {
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 1px 2px -1px var(--rgba--light-blue);
  transition: var(--transition--default);
}

.markdown__editor-wrapper:focus-within {
  box-shadow: 0 1px 6px -1px var(--rgba--light-blue);
}

.markdown.is-view .markdown__editor {
  position: absolute;
  top: 10%;
  left: 0;
  right: 0;
  max-width: 1085px;
  margin: 0 auto;
  border-radius: 8px;
  background: #fff;
  z-index: 250;
  overflow: hidden;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
}

.markdown__editor-edition-box {
  display: grid;
  grid-template-columns: 1fr 1fr;
}

.markdown__editor-edition-box.compact {
  grid-template-columns: 1fr;
}

.markdown__editor-draft {
  align-items: stretch;
}

.markdown__editor-draft >>> .app-textarea {
  font-family: 'Menlo', Courier, monospace;
  font-size: 12px;
  font-weight: 500;
  word-break: break-word;
  height: auto !important;
  min-height: 200px;
  line-height: 24px;
  letter-spacing: 0.5px;
  color: var(--c-secondary-700);
  box-shadow: none;
  outline: none;
  resize: none;
  overflow-y: auto !important;
}

.markdown__editor-preview,
.markdown__editor-draft >>> .app-textarea {
  border: 1px solid var(--c-secondary-400);
  border-bottom: 0;
  border-radius: 0;
}

.markdown__editor-preview {
  min-height: 300px;
  padding: 20px;
  /* border-radius: 4px 4px 0 0; */
  background-color: var(--c-secondary-300);
  border-left: 0;
}

.markdown__editor-actions {
  display: grid;
  grid-template-columns: auto auto;
  justify-content: flex-start;
  grid-gap: 10px;
  padding: 8px 10px;
  border-radius: 0 0 4px 4px;
  background-color: var(--c-light-gray-100);
}

.markdown__editor-actions >>> .submit-button {
  width: auto;
}

.markdown__editor-actions >>> .app-button {
  font-size: 13px;
  min-height: unset;
  height: auto;
  width: auto;
  padding: 5px 10px;
}

.markdown__editor-actions >>> .app-button--icon {
  width: 40px;
  border-radius: 4px;
}

.markdown__editor-actions >>> .app-button--icon,
.markdown__editor-actions >>> .app-button--icon i {
  transition: none;
}
</style>

<style src="@/assets/css/shared-styles/editBox.css" scoped></style>
